<template lang="pug">
  .component-switch
    .switch( @click="toggleSwitch")
      input.switch-input(:id="idEl", type='checkbox', :checked= 'active' :value="active")
      label.switch-paddle(:for="idEl")
        span(:class="{'switch-active':value, 'switch-inactive':!value}", v-html="Boolean(active) ? 'Yes' : 'No'")
    slot
</template>

<script>
export default {
  name: 'InputSwitch',
  props: ['value','idEl'],
  watch: {
    active: {
      handler() {
        //this.active = this.value
      }
    },
  },
  data() {
    return {
      active: this.value
    }
  },
  methods: {
    toggleSwitch() {
      this.active = !this.active
      this.$emit('input', this.active)
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InputSwitch.vue?0cb33dc6